import { createSelector } from '@reduxjs/toolkit'

const getCompanyId = (state: any) => state.company.companyId

export const companyIdSelector = createSelector(getCompanyId, (companyId) => companyId)

